import { useState, useEffect } from 'react'

// useState that mirrors its value to localStorage, so UI disclosure state
// (open/closed sections, expanded folders) survives refresh / re-login.
// JSON-encoded, so it works for booleans, arrays, and plain objects.
export const usePersistedState = (key, defaultValue) => {

    const [value, setValue] = useState(() => {
        try {
            const stored = localStorage.getItem(key)
            if (stored === null) {
                return defaultValue
            }
            return JSON.parse(stored)
        } catch {
            return defaultValue
        }
    })

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value))
        } catch {
            // ignore storage failures (private mode, quota) — state still works in-session
        }
    }, [key, value])

    return [value, setValue]
}
